import { NgModule } from '@angular/core';
import { EmojiImage } from './emoji-image.directive';

@NgModule({
  declarations: [ EmojiImage ],
  exports: [ EmojiImage ]
})
export class EmojiImageModule { }